import React from 'react';
import DepartmentCard from './DepartmentCard';

const DepartmentGrid = ({ 
  departmentsToUse, 
  getDepartmentProgress, 
  expandedDepartment, 
  toggleDepartment, 
  formatDate, 
  updateTaskStatus, 
  viewMode 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
      {departmentsToUse.map(dept => {
        const deptProgress = getDepartmentProgress(dept.tasks);
        const isExpanded = expandedDepartment === dept.name;
        
        return (
          <DepartmentCard 
            key={dept.name}
            dept={dept}
            deptProgress={deptProgress}
            isExpanded={isExpanded}
            toggleDepartment={toggleDepartment}
            formatDate={formatDate}
            updateTaskStatus={updateTaskStatus}
            viewMode={viewMode}
          />
        );
      })}
    </div>
  );
};

export default DepartmentGrid;
